import React, { Component } from "react";

class RestrictedContent extends Component {
  constructor(props) {
    super(props);
    this.state = { apiResponse: "" };
  }

  render() {
    return (
      <div className="alert alert-danger" role="alert">
        <meta http-equiv="refresh" content="2;url=/signOut" />
        You don't have permissions to access this content
      </div>
    );
  }
}

export default RestrictedContent;
